<script setup>
import {onMounted, ref} from 'vue';
import {useRouter} from 'vue-router';
import FileService from '@/services/FileService';
import PDF from 'pdf-vue3';
import {useI18n} from 'vue-i18n';
import {Capacitor} from "@capacitor/core";
import {Browser} from "@capacitor/browser";
import fileService from '@/services/FileService';

const {t} = useI18n();
const file = ref(null);
const router = useRouter();
const mediaId = router.currentRoute.value.params.id;

const isLoading = ref(false);

function navigateTo(to) {
  router.push(to);
}


onMounted(() => {
  getFile(mediaId);
});

function getFile(mediaId) {
  FileService.getMediaContent(mediaId)
      .then((response) => {
        file.value = response;
      })
      .catch((error) => {
        console.log(error);
      });
}

async function downloadFile() {
  const usedFile = file.value;
  const url = file.value.download_url;

  if (Capacitor.isNativePlatform()) {
    await Browser.open({
      url: url,
      windowName: '_system'
    });
  }

  fileService.downloadFileByPlatform(usedFile.content, usedFile.name, usedFile.extension);
}
</script>

<template>

  <div class="page-section">
    <div class="page-section__heading">
      <div class="row">
        <div class="col-2">
          <a @click="router.back()" class="page-section__heading__back"><i class="mdi mdi-arrow-left"></i> {{ t('fileDetail.back') }}</a>
        </div>
        <div class="col-8 text-center">
          <div class="page-section__title">
            {{ file?.name }}
          </div>
        </div>
      </div>
    </div>
    <div class="page-section__content">
      <div class="px-5 text-end">
        <button class="btn btn-primary" @click="downloadFile">Stáhnout</button>
      </div>
      <div class="px-5 py-5">
        <!--<editor-fold desc="PDF">-->
        <div class="py-3" v-if="file && file.extension === 'pdf'">
          <PDF :src="file.content"/>
        </div>
        <!--</editor-fold desc="PDF">-->

        <!--<editor-fold desc="IMAGES">-->
        <div class="py-3" v-if="file && ['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(file.extension)">
          <img :src="file.content" alt="file.name" class="img-fluid"/>
        </div>
        <!--</editor-fold desc="IMAGES">-->
      </div>
    </div>
  </div>

</template>

<style scoped>

</style>
